// extracted by mini-css-extract-plugin
module.exports = {"black":"#1f1f1f","white":"#fff","primary":"#19484b","dark":"#19484b","red":"#ef476f","yellow":"#ffd166","secondary":"#5cd68b","border":"#e3e6e7","light":"#f5f9f9","grey":"#767676"};